import { cloneDeep } from 'lodash';
import { compose, withHandlers, withState } from 'recompose';
import { sessionKVStore } from '../../../modules/infra/persistence';

const RemoteAppsContainer = compose(
  withState('remotes', 'setRemotes', () => {
    const allRemotes = cloneDeep(window.__squireRemotes);
    return Object.values(allRemotes).map((remote) => {
      const url = window.getRemoteUrl(remote.name);
      return {
        ...remote,
        url,
      };
    });
  }),
  withHandlers({
    updateRemoteUrl: props => (remoteName, newUrl) => {
      const updatedRemotes = props.remotes.map((remote) => {
        if (remote.name === remoteName) {
          return {
            ...remote,
            url: newUrl,
          };
        }

        return remote;
      });

      props.setRemotes(updatedRemotes);
    },
    saveRemotes: props => () => {
      const defaults = window.__squireRemotes;
      const overrides = props.remotes
        .filter((remote) => {
          const didUrlChange = remote.url !== defaults[remote.name].url;
          return didUrlChange;
        })
        .reduce((memo, changedRemote) => {
          return {
            ...memo,
            [changedRemote.name]: changedRemote.url,
          };
        }, {});

      sessionKVStore.setItem('__squireRemotes', JSON.stringify(overrides));
    },
  }),
);

export default RemoteAppsContainer;
